export default {
    toastObject: {
        message: "Error. Please try again later",
        type: "error",
        position: "top-right",
        duration: 5000
    }
}